const isArrayIndex = (index) => (Array.isArray(index) ? false : Number.isSafeInteger(index) && index >= 0);

export default isArrayIndex;
